// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assign-withdraw[data-v-da5a9e54] {\n  display: block;\n  width: 100%;\n  padding: 20px 30px;\n}\n.assign-withdraw__text[data-v-da5a9e54] {\n  padding-bottom: 20px;\n  font-size: 16px;\n}\n.assign-withdraw__btn[data-v-da5a9e54] {\n  width: auto;\n  padding: 0 30px;\n}\n", ""]);
// Exports
module.exports = exports;
